import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { changeEnterHTML } from 'src/utils/changeEnter';
import { trackingList } from 'src/utils/valueHTML';
import { getFontURL } from 'src/utils/getFontUrl';

const BasicScratchModalHTML: FC = () => {
  const bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  const bgOpacity = useSelector(
    (state: RootState) => state.imageUpload.bgImageBlur
  );
  const bgColor = useSelector((state: RootState) => state.imageUpload.bgColor);
  const radius = useSelector((state: RootState) => state.imageUpload.radius);
  const deeplink = useSelector(
    (state: RootState) => state.imageUpload.deeplink
  );
  const text = useSelector((state: RootState) => state.editText.text);
  const fontSize = useSelector((state: RootState) => state.editText.fontSize);
  const fontWeight = useSelector(
    (state: RootState) => state.editText.fontWeight
  );
  const color = useSelector((state: RootState) => state.editText.color);
  const fontFamily = useSelector(
    (state: RootState) => state.editText.fontFamily
  );
  const textAlign = useSelector((state: RootState) => state.editText.textAlign);

  const btnText = useSelector((state: RootState) => state.buttons.btnText);
  const btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  const btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  const btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  const btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  const btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  const btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  const btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  const btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );

  const btnAgain = useSelector((state: RootState) => state.buttons.btnAgain);

  const tracking = useSelector((state: RootState) => state.trackings.tracking);
  const button1 = useSelector((state: RootState) => state.trackings.button1);
  const button2 = useSelector((state: RootState) => state.trackings.button2);

  const backgroundDimmed = bgOpacity?.bgDimmed / 100;
  const displayValue = backgroundDimmed >= 0.01 ? backgroundDimmed : 0.7;

  const titleFontURL = getFontURL(fontFamily?.title);
  const subTitleFontURL = getFontURL(fontFamily?.sub_title);
  const buttonURL = getFontURL(btnFontFamily?.button);
  const bottomLeftButtonURL = getFontURL(btnFontFamily?.bottom_left_button);
  const bottomRightButtonURL = getFontURL(btnFontFamily?.bottom_right_button);

  const style = `
  @font-face {
    font-family: 'title';
    src: url(${titleFontURL});
  }
  @font-face {
    font-family: 'sub_title';
    src: url(${subTitleFontURL});
  }
  @font-face {
    font-family: 'button';
    src: url(${buttonURL});
  }
  @font-face {
    font-family: 'bottom_left_button';
    src: url(${bottomLeftButtonURL});
  }
  @font-face {
    font-family: 'bottom_right_button';
    src: url(${bottomRightButtonURL});
  }

    /* reset */
    * {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      list-style: none;
      text-decoration: none;      
    }
    
    html,
    body {
      height: 100%;
      overflow: hidden;
      font-size: 16px;      
    }
    main {
      height: 100%;
      position: relative;
    }
    a {
      color: #000000;
      cursor: pointer;
    }
    button {
      background: none;
      border: none;
    }

   .root {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      position: relative;
      background: none;
    }

    .background {      
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      background: rgba(0, 0, 0, ${displayValue});
    }    
    .center {
      width: 310px;
      position: absolute;
      overflow: hidden;
      top: 50%;
      transform: translate(0%, -50%);
      display: flex;
      flex-direction: column;
    }

    .modal_wrapper {        
      display: flex;
      flex-direction: column;
      padding: 8px 8px 0px 8px;
      border-radius: ${radius?.background}px;

      background: ${bgColor?.background};

      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
    }
   
    .contents_wrapper {
      width: 100%;
    }

    .contents_box {
      width: 100%;
      height: 100%;
      margin-top: 20px;
    }

    .contents_box .title {
      width: 100%;      
      display: flex;
      align-items: center;
      margin-bottom: 7px;
    }
    
    .title .title_inner {
      width: 100%;
      text-align: ${textAlign?.title};
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: 1.4;
      color: ${color?.title};
      font-size: ${fontSize?.title}rem;
      font-weight: ${fontWeight?.title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.title
        )
          ? fontFamily.title
          : 'title'
      };
    }

    .contents_box .sub_title {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
    }

    .contents_box .sub_title_inner {
      width: 100%;  
      text-align: ${textAlign?.sub_title};
      text-overflow: ellipsis;
      overflow: hidden;
      line-height: 1.54;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 4;
      
      color: ${color?.sub_title};
      font-size: ${fontSize?.sub_title}rem;
      font-weight: ${fontWeight?.sub_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.sub_title
        )
          ? fontFamily.sub_title
          : 'sub_title'
      };
    }

    .btn_wrapper {
      width: 100%;
      margin: 16px 0px 20px 0px;
    }
    .btn_wrapper button {
      width: 100%;
      height: 48px;
      outline: 0;
      border: 0;
      padding: 0 16px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      font-size: ${btnFontSize?.button}rem;
      font-weight: ${btnFontWeight?.button};
      color: ${btnColor?.button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.button
        )
          ? btnFontFamily.button
          : 'button'
      };
      border-radius: ${radius?.button}px;
      background-color:rgba(${btnBgColorR?.button},${btnBgColorG?.button}, ${
    btnBgColorB?.button
  }, ${btnBgColorA?.button});
    }

    .bottom_wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 11px
    }
    
    .bottom_wrapper .style01 {
      width: 100%;
      display: flex;
      align-items: center;
      gap: 8px;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      color: ${btnColor?.bottom_left_button};      
      font-weight: ${btnFontWeight?.bottom_left_button};
      font-size: ${btnFontSize?.bottom_left_button}rem;
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.bottom_left_button
        )
          ? btnFontFamily.bottom_left_button
          : 'bottom_left_button'
      };
    }
    .bottom_wrapper .style02 {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      text-align: right;
      color: ${btnColor?.bottom_right_button};      
      font-weight: ${btnFontWeight?.bottom_right_button};
      font-size: ${btnFontSize?.bottom_right_button}rem;
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.bottom_right_button
        )
          ? btnFontFamily.bottom_right_button
          : 'bottom_right_button'
      };
    }
      /* scratch css */

		.scratch-container {
			width: 100%;
			height: 100%;
			position: relative;
		}

		#scratchCard {
			border-radius: ${radius?.image}px;
			position: absolute;
			top: 0;
			left: 0;
			background: none;
			opacity: 1;
			transition: opacity 0.8s ease-out;
		}

		#scratchCard.revealed {
			opacity: 0;
		}

		#resultContainer {
			border-radius: ${radius?.image}px;
			width: 100%;
			height: 100%;

			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 24px;
			font-weight: bold;
			color: #000000;
			background-color: ${bgColor?.background};
		}
  `;

  const deeplink_list = JSON.stringify(deeplink?.background);

  const html = `
    <div class="root">
       <div class="background" onclick="appboyBridge.logClick('background'); appboyBridge.closeMessage();"></div>
       <div class="center">
          <div class="modal_wrapper">
            <div style="width: 100%; height: 100%">
              <div class="scratch-container">
                <div id="resultContainer">
                  <img
                    style="width: 295px; height: 295px; border-radius: ${
                      radius?.image
                    }px; object-fit: cover"
                    src=${bgImage?.image}
                    alt="result"
                  />
                </div>
                <canvas id="scratchCard" width="0" height="0" />
              </div>
            </div>
            <div class="contents_wrapper">
              <div class="contents_box">
                <div class="title">
                  <div class="title_inner">${changeEnterHTML(text?.title)}</div>
                </div>
                <div class="sub_title">
                  <div class="sub_title_inner">${changeEnterHTML(
                    text?.sub_title
                  )}</div>
                </div>
              </div>
              <div class="btn_wrapper">
                <button class="button_text" style="opacity: 0.5" disabled>
                  ${btnText?.button}
                </button>
              </div>
            </div>
          </div>
          <div class="bottom_wrapper">
            <button class="style01">${btnText?.bottom_left_button}</button>
            <div style="display: flex; justify-content: center; align-items: center">
              <button class="style02">${btnText?.bottom_right_button}</button>
              <span class="material-icons" style="font-size: 20px; padding-bottom: 1.6px; color: ${
                btnColor?.bottom_right_button
              }">close</span>
            </div>
          </div>
        </div>
        <div id="test" style="display:none;">
            ${deeplink_list}
        </div> 
    </div>  
    `;

  const tracking_list = JSON.stringify([
    tracking?.button,
    tracking?.bottom_left_button,
    tracking?.bottom_right_button
  ]);

  const tracking_button_list = trackingList(
    'BASIC SCRATCH MODAL',
    button1,
    button2
  );

  const js = `
    document.addEventListener("DOMContentLoaded", function() {       
    let content = document.getElementById("test").textContent;
    // 불필요한 줄바꿈과 탭 문자를 제거합니다.
    let link = content.replace(/\\n|\\t/g, "").trim();
    let deeplink = JSON.parse(link);

    let tracking = ${tracking_list};
    let button1 = ${tracking_button_list[0]};
    let button2 = ${tracking_button_list[1]};

    document.querySelector(".btn_wrapper").addEventListener("click", function() {
        if (document.querySelector(".btn_wrapper button").disabled) {
            return;
        }
        try {
            appboyBridge.logClick(tracking[0][0]);
            if (button1[0].indexOf(0) !== -1) {
                appboyBridge.logClick("0");
            }
            if (button2[0].indexOf(0) !== -1) {
                appboyBridge.logClick("1");
            }
        } catch (err) {}
        window.location = deeplink;
    });

    document.querySelector(".style01").addEventListener("click", function() {
        try {
            if ("${btnAgain?.type}" === "attribute") {
                appboyBridge.getUser().setCustomUserAttribute("${btnAgain?.bottom_left_button}", new Date());
            }
            if ("${btnAgain?.type}" === "event") {
                appboyBridge.logCustomEvent("${btnAgain?.bottom_left_button}");
            }
        } catch (err) {}

        try {
            appboyBridge.logClick(tracking[1][0]);
            if (button1[1].indexOf(0) !== -1) {
                appboyBridge.logClick("0");
            }
            if (button2[1].indexOf(0) !== -1) {
                appboyBridge.logClick("1");
            }
        } catch (err) {}
        appboyBridge.closeMessage();
    });

    document.querySelector(".style02").addEventListener("click", function() {
        try {
            appboyBridge.logClick(tracking[2][0]);
            if (button1[2].indexOf(0) !== -1) {
                appboyBridge.logClick("0");
            }
            if (button2[2].indexOf(0) !== -1) {
                appboyBridge.logClick("1");
            }
        } catch (err) {}
        appboyBridge.closeMessage();
    });
})
  `;
  const scratch_js = `    
		// 설정값 객체
		const CONFIG = {
			threshold: 0.3,
			lineWidth: 40,
			maxSize: 480,
			imagePath:
				"data:image/png;base64,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",
		};

		// 상태 객체
		const State = {
			isDrawing: false,
			isRevealed: false,
			lastX: 0,
			lastY: 0,
			scratchedPixels: 0,
			totalPixels: 0,
		};

		// 초기화 함수들
		const initializeCanvas = (canvas, container) => {
			const size = container.clientWidth;
			canvas.width = size;
			canvas.height = size;

			// 캔버스 스타일도 명시적으로 설정
			canvas.style.width = "100%";
			canvas.style.height = "100%";

			return canvas;
		};

		const initializeContainer = (container, size) => {
			container.style.width = size + "px";
			container.style.height = size + "px";
			return container;
		};

		// 그리기 관련 순수 함수들
		const setupContext = (ctx) => {
			ctx.globalCompositeOperation = "destination-out";
			ctx.lineWidth = CONFIG.lineWidth;
			ctx.lineCap = "round";
			ctx.lineJoin = "round";
			return ctx;
		};

		const drawScratchLine = (ctx, from, to) => {
			const midPoint = {
				x: (from.x + to.x) / 2,
				y: (from.y + to.y) / 2,
			};

			ctx.beginPath();
			ctx.moveTo(from.x, from.y);
			ctx.quadraticCurveTo(from.x, from.y, midPoint.x, midPoint.y);
			ctx.lineTo(to.x, to.y);
			ctx.stroke();
		};

		// 이벤트 핸들러
    const createEventHandlers = (canvas, ctx, state) => {
      const getPosition = (e) => {
          const rect = canvas.getBoundingClientRect();
          const clientX = e.clientX || (e.touches && e.touches[0].clientX);
          const clientY = e.clientY || (e.touches && e.touches[0].clientY);
          return {
            x: clientX - rect.left,
            y: clientY - rect.top,
          };
      };

      const handleStart = (e) => {
        state.isDrawing = true;
        const pos = getPosition(e);
        state.lastX = pos.x;
        state.lastY = pos.y;
      };

      const handleMove = (e) => {
        if (!state.isDrawing || state.isRevealed) return;
        e.preventDefault();

        const pos = getPosition(e);
        setupContext(ctx);
        drawScratchLine(ctx, { x: state.lastX, y: state.lastY }, { x: pos.x, y: pos.y });

        state.lastX = pos.x;
        state.lastY = pos.y;
      };

      const handleEnd = () => {
        if (state.isDrawing) {
          checkProgress(canvas, ctx); // 손을 뗄 때 진행도 체크
        }
        state.isDrawing = false;
      };

      return { handleStart, handleMove, handleEnd };
    };

		// 진행도 체크 함수
		const checkProgress = (canvas, ctx) => {
			const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
			const pixels = imageData.data;

			const scratchedPixels = pixels.filter((_, i) => i % 4 === 3 && pixels[i] === 0).length;

			const progress = scratchedPixels / (canvas.width * canvas.height);

			if (progress > CONFIG.threshold && !State.isRevealed) {
				State.isRevealed = true;
				canvas.classList.add("revealed");
				const button = document.querySelector(".btn_wrapper button");
				button.style.opacity = "1";
				button.disabled = false;
			}
		};

		// 메인 초기화 함수
		const initializeScratchCard = () => {
			const canvas = document.getElementById("scratchCard");
			const ctx = canvas.getContext("2d");
			const container = document.querySelector(".scratch-container");

			initializeCanvas(canvas, container);
			initializeContainer(container, container.clientWidth);

			const scratchImage = new Image();
			scratchImage.src = CONFIG.imagePath;
			scratchImage.onload = () => {
				ctx.drawImage(scratchImage, -5, 0, canvas.width + 10, canvas.height + 10);

				const handlers = createEventHandlers(canvas, ctx, State);

				// 이벤트 리스너 등록
				canvas.addEventListener("mousedown", handlers.handleStart);
				canvas.addEventListener("mousemove", handlers.handleMove);
				canvas.addEventListener("mouseup", handlers.handleEnd);

				canvas.addEventListener("touchstart", handlers.handleStart);
				canvas.addEventListener("touchmove", handlers.handleMove);
				canvas.addEventListener("touchend", handlers.handleEnd);

				// 모바일에서 스크롤 방지
				document.body.addEventListener(
					"touchmove",
					(e) => {
						if (e.target === canvas) e.preventDefault();
					},
					{ passive: false }
				);
			};

			// 리사이즈 이벤트
			window.addEventListener("resize", initializeScratchCard);
		};

		// 앱 시작
		document.addEventListener("DOMContentLoaded", initializeScratchCard);	
  `;
  return (
    <>
      <head>
        <meta charSet="UTF-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />
        <meta
          httpEquiv="Cache-Control"
          content="no-cache, no-store, must-revalidate"
        />
        <meta httpEquiv="Expires" content="0" />
        <meta httpEquiv="Pragma" content="no-cache" />

        {/* google font */}
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Archivo:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          rel="stylesheet"
          as="style"
          href="https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/static/pretendard.min.css"
        />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/icon?family=Material+Icons"
        />
        <style dangerouslySetInnerHTML={{ __html: style }} />
        <script
          dangerouslySetInnerHTML={{
            __html: `               
         (function () {
          function adjustFontSize() {
            var actualSize = Math.round(parseFloat(window.getComputedStyle(document.documentElement).fontSize));
            if (actualSize !== 16) {              
              var newFontSize = (16 * 16) / actualSize;
              document.documentElement.style.fontSize = newFontSize + "px";                            
            }
          }              

          // adjust font size before body load
              adjustFontSize();
              })();                           
          `
          }}
        />
      </head>
      <body dangerouslySetInnerHTML={{ __html: html }} />
      <script dangerouslySetInnerHTML={{ __html: js }} />
      <script dangerouslySetInnerHTML={{ __html: scratch_js }} />
    </>
  );
};
export default BasicScratchModalHTML;
